// extracted by mini-css-extract-plugin
export var blue = "_redotech-arbiter-lib-icon-redo-icon-blue";
export var brand = "_redotech-arbiter-lib-icon-redo-icon-brand";
export var darkGrey = "_redotech-arbiter-lib-icon-redo-icon-darkGrey";
export var disabled = "_redotech-arbiter-lib-icon-redo-icon-disabled";
export var disabledSubtle = "_redotech-arbiter-lib-icon-redo-icon-disabled-subtle";
export var error = "_redotech-arbiter-lib-icon-redo-icon-error";
export var green = "_redotech-arbiter-lib-icon-redo-icon-green";
export var grey = "_redotech-arbiter-lib-icon-redo-icon-grey";
export var icon = "_redotech-arbiter-lib-icon-redo-icon-icon";
export var inherit = "_redotech-arbiter-lib-icon-redo-icon-inherit";
export var lightGrey = "_redotech-arbiter-lib-icon-redo-icon-lightGrey";
export var orange = "_redotech-arbiter-lib-icon-redo-icon-orange";
export var pink = "_redotech-arbiter-lib-icon-redo-icon-pink";
export var primary = "_redotech-arbiter-lib-icon-redo-icon-primary";
export var purple = "_redotech-arbiter-lib-icon-redo-icon-purple";
export var red = "_redotech-arbiter-lib-icon-redo-icon-red";
export var secondary = "_redotech-arbiter-lib-icon-redo-icon-secondary";
export var success = "_redotech-arbiter-lib-icon-redo-icon-success";
export var tertiary = "_redotech-arbiter-lib-icon-redo-icon-tertiary";
export var warning = "_redotech-arbiter-lib-icon-redo-icon-warning";
export var warningSecondary = "_redotech-arbiter-lib-icon-redo-icon-warning-secondary";
export var white = "_redotech-arbiter-lib-icon-redo-icon-white";
export var yellow = "_redotech-arbiter-lib-icon-redo-icon-yellow";